class WishList {
  constructor() {
    this.wishlistHandler();
  }

  wishlistHandler() {
    const wishlistHeaderButton = document.querySelectorAll(".thb-wishlist");

    wishlistHeaderButton.forEach(function (wishlistButton) {
      wishlistButton.addEventListener("click", function (event) {
        event.preventDefault();
        console.log("clicked");
        const iwishFloatWrapper = document.querySelector(
          ".iwish_float_wrapper"
        );
        if (iwishFloatWrapper) {
          iwishFloatWrapper.click();
        }
      });
    });
  }
}

// Wait until the document is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Monitor for the dynamically loaded iwishlist-2.0.js file
  const monitorForWishlistScript = setInterval(() => {
    // Get all script elements in the document
    const scripts = Array.from(document.getElementsByTagName("script"));

    // Check if iwishlist-2.0.js has been loaded
    const wishlistScript = scripts.find((script) =>
      script.src.includes("iwishlist-2.0.js")
    );

    // If the wishlist script is found and has finished loading
    if (
      (wishlistScript && wishlistScript.readyState === "complete") ||
      wishlistScript.readyState === "loaded"
    ) {
      clearInterval(monitorForWishlistScript);

      // Run your code after iwishlist-2.0.js has loaded
      console.log("iwishlist-2.0.js loaded successfully");

      // Instantiate the WishList class
      if (typeof WishList === "function") {
        new WishList();
        console.log("WishList instantiated successfully.");
      } else {
        console.error("WishList class is not available.");
      }

      // Wait for iwish_qvBtn_click function
      const interval = setInterval(() => {
        if (typeof window.iwish_qvBtn_click === "function") {
          clearInterval(interval);
          console.log("testing");
          window.iwish_qvBtn_click();
        } else {
          console.log("window.iwish_qvBtn_click is not yet available.");
        }
      }, 100);
    }
  }, 100);

  new WishList(); // Instantiate the CartRedirect class on page load
});
